import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

export interface IBillPayToResponse {
    payTo: string;
}

export class BillPayToCell extends PureComponent<IGridCellRenderProps<IBillPayToResponse>> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }
        return (
            <div className="billPayToCell flex align-items-center" data-testid={field.full}>
                <TextTruncate>{cellValue.payTo}</TextTruncate>
            </div>
        );
    }
}

export const columnBillPayTo: IClientGridColumn<IBillPayToResponse> = {
    columnType: GridColumnType.billPayTo,
    Cell: BillPayToCell,
};
